import moment from "moment";
import { DateService } from "@topline/services/dateService";
import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ForecastParametersProvider } from "../services/forecastParametersProvider";
import { ImsDataService } from "../services/initializeAndRefresh/imsDataService";
(function (module) {
    "use strict";

    module.component("forecastParameters", {
        template: require("./forecastParametersComponent.html"),
        bindings: {
            forecast: "=",
            showValidationErrors: "=",
            isValid: "=",
            lockForEdition: "=",
            imsLatestData: "<"
        },
        controller: [
            "$scope",
            ForecastParametersProvider.componentName,
            angularServicesNames.$translate,
            ImsDataService.componentName,
            "brandGroupNameService",
            "AlertService",
            AgGridService.componentName,
            DateService.componentName,
            function (
                this: $TSFixMe,
                $scope: $TSFixMe,
                forecastParametersProvider: ForecastParametersProvider,
                $translate: ng.translate.ITranslateService,
                imsDataService: ImsDataService,
                brandGroupNameService: $TSFixMe,
                AlertService: AlertService,
                agGridService: AgGridService,
                dateService: DateService
            ) {
                var $ctrl = this;

                $ctrl.brandsFromNewProducts = [];
                $ctrl.brandsFromIms = [];

                $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

                function recalculateForecastDateRange() {
                    const dataSource = $ctrl.forecast.parameters.dataSource;

                    if (!dataSource || !$ctrl.forecast.market || !$ctrl.forecast.market.id) return;

                    const skuIds = _.without(
                        _.flatten(_.map($ctrl.brandsFromIms, (b: $TSFixMe) => _.pluck(b.skus, "externalId"))),
                        null
                    );

                    $ctrl.paramsRecalculateOperation = imsDataService
                        .getLatestDataDate(skuIds, $ctrl.forecast.market.id)
                        .then(function (items: $TSFixMe) {
                            if ($ctrl.isForecastSet === false) {

                                const forecastStartDate = dateService.getForecastStartDate(
                                    $ctrl.forecastDefaults.forecastStartDate,
                                    $ctrl.forecast.market.historicalDataEnd,
                                    $ctrl.forecast.market.budgetYear,
                                    $ctrl.forecast.parameters.dataSource.name
                                );

                                const historicalDataStart = dateService.getHistoricalDataStart(
                                    forecastStartDate as Date,
                                    $ctrl.forecast.market.historicalDataStart,
                                    $ctrl.forecastDefaults.defaultHistoricalDataPeriod
                                );

                                const historicalDataEnd = dateService.getHistoricalDataEnd(
                                    forecastStartDate as Date,
                                    $ctrl.forecast.market.historicalDataEnd
                                );

                                $ctrl.forecast.parameters.forecastStartDate = forecastStartDate;

                                $ctrl.forecast.parameters.forecastEndDate = dateService.getForecastEndDate(
                                    forecastStartDate,
                                    historicalDataEnd,
                                    $ctrl.forecastDefaults.defaultForecastPeriod,
                                    $ctrl.forecast.parameters.dataSource.name
                                );

                                $ctrl.forecast.parameters.historicalDataStart = historicalDataStart;

                                $ctrl.forecast.parameters.historicalDataEnd = historicalDataEnd;
                            }

                            $ctrl.historicalRangeDataSource = items;
                            $ctrl.brandGridApi.core.refresh();
                        });
                }

                function reloadMarkets() {
                    if ($ctrl.isForecastSet) return;

                    const dataSourceId = angular._get($ctrl.forecast, "parameters.dataSource.urlPart", null);

                    const budgetYear = angular._get($ctrl.forecast, "parameters.marketBudgetYear", null);
                    forecastParametersProvider.getMyMarkets(dataSourceId, budgetYear).then(function (items) {
                        $ctrl.markets = items;

                        var marketId = angular._get($ctrl.forecast, "market.id", null);
                        if (marketId) {
                            $ctrl.forecast.market = _.find($ctrl.markets, (m: $TSFixMe) => m.id == marketId);

                            if (angular.isUndefinedOrNull($ctrl.forecast.market)) {
                                $ctrl.marketChanged();
                            }
                        }
                    });
                }

                forecastParametersProvider.getDataSources().then(function (items: $TSFixMe) {
                    $ctrl.dataSources = items;
                });

                $ctrl.dataSourceChanged = () => {
                    setBudgetYearIfNotPresent();
                    reloadMarkets();
                    reloadForecastMethods();
                };

                $ctrl.marketBudgetYearChanged = () => reloadMarkets();

                function setBudgetYearIfNotPresent() {
                    $ctrl.forecast.parameters.marketBudgetYear = angular.isUndefinedOrNull(
                        $ctrl.forecast.parameters.marketBudgetYear
                    )
                        ? dateService.getDefaultBudgetYear()
                        : $ctrl.forecast.parameters.marketBudgetYear;
                }

                function reloadForecastMethods() {
                    forecastParametersProvider
                        .getForecastMethods($ctrl.forecast.parameters.dataSource.urlPart)
                        .then(function (items: $TSFixMe) {
                            $ctrl.forecastMethods = items;

                            if ($ctrl.isForecastSet) {
                                $ctrl.forecastMethod = _.find($ctrl.forecastMethods, function (item: $TSFixMe) {
                                    return (item.methodId = $ctrl.forecast.parameters.forecastMethod.methodId);
                                });
                            }
                        });
                }

                forecastParametersProvider.getForecastDefaults().then(function (data: $TSFixMe) {
                    $ctrl.forecastDefaults = data;
                });

                $ctrl.marketChanged = function () {
                    if ($ctrl.isForecastSet) return;

                    if (angular.isUndefinedOrNull($ctrl.forecast.market)) {
                        $ctrl.brandsFromIms = [];
                        $ctrl.gridApi.setRowData($ctrl.brandsFromIms);
                        return;
                    }

                    $ctrl.paramsRecalculateOperation = forecastParametersProvider
                        .getBrands($ctrl.forecast.market.id)
                        .then(function (items: $TSFixMe) {
                            items.forEach(function (item: $TSFixMe) {
                                item.brandGroup = "";
                                if (item.isSelected) {
                                    for (let sku of item.skus) {
                                        sku.isSelected = true;
                                    }
                                }
                            });

                            $ctrl.brandsFromIms = items;
                            $ctrl.gridApi.setRowData($ctrl.brandsFromIms);

                            recalculateForecastDateRange();

                            if (
                                !_.some($ctrl.brandsFromIms, (brand: $TSFixMe) =>
                                    _.some(brand.skus, (sku: $TSFixMe) => sku.oracleIndex && sku.canBeForecast)
                                )
                            ) {
                                AlertService.warning($translate.instant("FORECAST.PARAMETERS.NO_SKU_TO_FORECAST"));
                            }
                        });
                };

                $ctrl.forecastMethodChanged = function () {
                    $ctrl.forecast.parameters.forecastMethod = {
                        name: $ctrl.forecastMethod.name,
                        methodId: $ctrl.forecastMethod.methodId
                    };
                    $ctrl.gridApi.forEachNode((node: $TSFixMe) => node.checkRowSelectable());
                    $ctrl.gridApi.forEachDetailGridInfo((detailGridInfo: $TSFixMe) => {
                        detailGridInfo.api.forEachNode((node: $TSFixMe) => node.checkRowSelectable());
                    });
                };

                $ctrl.filter = function (x: $TSFixMe) {
                    return x.oracleIndex;
                };

                function getParentRowNode(childApi: $TSFixMe) {
                    let oracleIndex: $TSFixMe = null;
                    childApi.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                        if (rowNode.data.oracleIndex) {
                            oracleIndex = rowNode.data.oracleIndex;
                        }
                    });

                    var node = null;
                    $ctrl.gridApi.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                        if (_.some(rowNode.data.skus, (x: $TSFixMe) => x.oracleIndex == oracleIndex)) {
                            node = rowNode;
                        }
                    });
                    return node;
                }

                $scope.getHistoricalDataRange = function (entity: $TSFixMe) {
                    function valueOf(resultData: $TSFixMe) {
                        return resultData.year * 100 + resultData.month;
                    }
                    if ($ctrl.historicalRangeDataSource) {
                        var filteredData = _.filter(
                            $ctrl.historicalRangeDataSource,
                            function (historicalData: $TSFixMe) {
                                var productId = historicalData.productId;

                                return _.find(entity.skus, function (sku: $TSFixMe) {
                                    return sku.externalId == productId;
                                });
                            }
                        );

                        var maxDate = _.max(filteredData, valueOf);
                        if (maxDate && typeof maxDate != "number") {
                            return moment(maxDate.year + "-" + maxDate.month, "YYYY-MM").format("YYYY-MM");
                        }
                    }
                };

                $ctrl.$onInit = () => {
                    $ctrl.showValidationErrors = function () {
                        $ctrl.parametersForm.$submitted = true;

                        if ($ctrl.forecast.parameters.forecastType.typeId == "dot") {
                            $ctrl.gridApi.forEachNode(function (node: $TSFixMe) {
                                if (_.some(node.data.skus, (s: $TSFixMe) => !s.dddFact && s.isSelected)) {
                                    node.setExpanded(true);
                                }
                            });
                        }
                    };

                    $ctrl.lockForEdition = function () {
                        $ctrl.isForecastSet = true;
                    };

                    $ctrl.isForecastSet = !angular.equals($ctrl.forecast, {});

                    initGrid();
                    reloadMarkets();
                    if (!$ctrl.isForecastSet) {
                        brandGroupNameService.get().then((items: $TSFixMe) => {
                            var columnDef = _.find(
                                $ctrl.brandGridOptions.columnDefs,
                                (config: $TSFixMe) => config.field == "brandGroup"
                            );

                            var names = _.map(items, (x: $TSFixMe) => x.name);
                            names.unshift("");
                            columnDef.cellEditorParams.values = names;
                        });
                    }

                    if ($ctrl.isForecastSet && $ctrl.forecast.market) {
                        createBrandsFromIms();
                        reloadForecastMethods();
                    }

                    processWatches();
                };

                function initGrid() {
                    $ctrl.brandGridOptions = {
                        columnDefs: [
                            {
                                headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.IS_SELECTED"),
                                checkboxSelection: true,
                                hide: $ctrl.isForecastSet
                            },
                            {
                                field: "name",
                                headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.BRAND"),
                                cellClass: (params: $TSFixMe) => (params.data.externalId ? "" : "new-product-cell"),
                                suppressMenu: true,
                                filter: "agTextColumnFilter",
                                filterParams: { newRowsAction: "keep" },
                                cellRenderer: "agGroupCellRenderer"
                            },
                            {
                                field: "brandGroup",
                                suppressMenu: true,
                                editable: () => !$ctrl.isForecastSet,
                                cellEditor: "agRichSelectCellEditor",
                                cellEditorParams: {
                                    values: []
                                },
                                filter: "agSetColumnFilter",
                                filterParams: { newRowsAction: "keep" },
                                hide: $ctrl.isForecastSet
                            },
                            {
                                field: "company",
                                headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.COMPANY"),
                                suppressMenu: true,
                                filter: "agSetColumnFilter",
                                filterParams: { newRowsAction: "keep" },
                                hide: $ctrl.isForecastSet
                            },
                            {
                                field: "skus.length",
                                headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.SKU_COUNT"),
                                suppressMenu: true,
                                filter: "agNumberColumnFilter",
                                filterParams: { newRowsAction: "keep" }
                            },
                            {
                                field: "historicalData",
                                headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.HISTORICAL_DATA"),
                                suppressMenu: true,
                                cellRenderer: () =>
                                    '<div class="ui-grid-cell-contents">{{getHistoricalDataRange(data)}}</div>',
                                hide: $ctrl.isForecastSet
                            }
                        ],
                        onGridReady: function (config: $TSFixMe) {
                            $ctrl.gridApi = config.api;
                            config.api.sizeColumnsToFit();
                            if ($ctrl.brandsFromIms) {
                                config.api.setRowData($ctrl.brandsFromIms);
                            }
                        },
                        onGridSizeChanged: (config: $TSFixMe) => {
                            config.api.sizeColumnsToFit();
                        },
                        isRowSelectable: function (rowNode: $TSFixMe) {
                            if (
                                !rowNode.data.externalId &&
                                (!$ctrl.forecast.parameters.forecastMethod ||
                                    $ctrl.forecast.parameters.forecastMethod.methodId == "sku")
                            ) {
                                return false;
                            }
                            return rowNode.data ? rowNode.data.hasSkusOwnedByMe : false;
                        },
                        floatingFilter: true,
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        animateRows: true,
                        pagination: true,
                        paginationPageSize: 10,
                        masterDetail: true,
                        rowSelection: "multiple",
                        domLayout: "autoHeight",
                        groupSelectsChildren: true,
                        suppressRowClickSelection: true,
                        suppressHorizontalScroll: true,
                        onRowSelected: function (e: $TSFixMe) {
                            if (e.node.isSelected()) {
                                if (e.node.detailNode) {
                                    e.node.detailNode.detailGridInfo.api.selectAll();
                                } else {
                                    for (const sku of e.data.skus) {
                                        sku.isSelected = true;
                                    }
                                }
                            } else {
                                if (e.node.detailNode) {
                                    e.node.detailNode.detailGridInfo.api.deselectAll();
                                } else {
                                    for (const sku of e.data.skus) {
                                        sku.isSelected = false;
                                    }
                                }
                            }
                            e.data.isSelected = e.node.isSelected();
                        },
                        localeTextFunc: agGridService.transalteFunc,
                        detailCellRendererParams: {
                            detailGridOptions: {
                                columnDefs: [
                                    {
                                        headerValueGetter: () =>
                                            $translate.instant("FORECAST.PARAMETERS.GRID.IS_SELECTED"),
                                        checkboxSelection: true,
                                        hide: $ctrl.isForecastSet
                                    },
                                    {
                                        field: "name",
                                        headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.SKUS"),
                                        suppressMenu: true
                                    },
                                    {
                                        field: "pharmacyMarket",
                                        headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.MARKET"),
                                        suppressMenu: true
                                    },
                                    {
                                        field: "dddFact",
                                        headerValueGetter: () =>
                                            $translate.instant("FORECAST.PARAMETERS.GRID.DDD_FACT"),
                                        suppressMenu: true,
                                        editable: () => !$ctrl.isForecastSet,
                                        cellEditor: "agTextCellEditor",
                                        valueSetter: function (params: $TSFixMe) {
                                            if (params.newValue && typeof params.newValue === "string") {
                                                return (params.data.dddFact = parseFloat(
                                                    params.newValue.replace(",", ".")
                                                ));
                                            }
                                            return (params.data.dddFact = params.newValue);
                                        },
                                        cellClass: (params: $TSFixMe) => {
                                            if (
                                                !params.data.dddFact &&
                                                params.data.isSelected &&
                                                $ctrl.forecast.parameters.forecastType &&
                                                $ctrl.forecast.parameters.forecastType.typeId == "dot"
                                            )
                                                return "ui-grid-cell-custom-invalid";
                                            else return "";
                                        }
                                    },
                                    {
                                        field: "oracleIndex",
                                        headerValueGetter: () =>
                                            $translate.instant("FORECAST.PARAMETERS.GRID.ORACLE_INDEX"),
                                        suppressMenu: true
                                    },
                                    {
                                        field: "owner",
                                        headerValueGetter: () => $translate.instant("FORECAST.PARAMETERS.GRID.OWNER"),
                                        suppressMenu: true,
                                        hide: $ctrl.isForecastSet
                                    }
                                ],
                                rowSelection: "multiple",
                                domLayout: "autoHeight",
                                groupSelectsChildren: true,
                                suppressRowClickSelection: true,
                                stopEditingWhenGridLosesFocus: true,
                                onModelUpdated: function (e: $TSFixMe) {
                                    let node = getParentRowNode(e.api);
                                    // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                                    if (node.isSelected()) {
                                        e.api.selectAll();
                                    }
                                },
                                onSelectionChanged: function (e: $TSFixMe) {
                                    let selectableRowCount = 0;
                                    e.api.forEachNode(function (rowNode: $TSFixMe, index: $TSFixMe) {
                                        if (rowNode.selectable) {
                                            ++selectableRowCount;
                                        }
                                    });

                                    let node = getParentRowNode(e.api);
                                    if (node) {
                                        if (e.api.getSelectedNodes().length == 0) {
                                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'isSelected' does not exist on type 'neve... Remove this comment to see the full error message
                                            if (node.isSelected()) {
                                                // @ts-expect-error ts-migrate(2339) FIXME: Property 'setSelected' does not exist on type 'nev... Remove this comment to see the full error message
                                                node.setSelected(false);
                                            }
                                        } else if (e.api.getSelectedNodes().length == selectableRowCount) {
                                            // @ts-expect-error ts-migrate(2339) FIXME: Property 'isSelected' does not exist on type 'neve... Remove this comment to see the full error message
                                            if (!node.isSelected()) {
                                                // @ts-expect-error ts-migrate(2339) FIXME: Property 'setSelected' does not exist on type 'nev... Remove this comment to see the full error message
                                                node.setSelected(true);
                                            }
                                        }
                                    }
                                },
                                isRowSelectable: function (rowNode: $TSFixMe) {
                                    if (
                                        !rowNode.data.externalId &&
                                        (!$ctrl.forecast.parameters.forecastMethod ||
                                            $ctrl.forecast.parameters.forecastMethod.methodId == "sku")
                                    ) {
                                        return false;
                                    }
                                    return rowNode.data ? rowNode.data.canBeForecast : false;
                                },
                                onRowSelected: function (e: $TSFixMe) {
                                    e.data.isSelected = e.node.isSelected();
                                },
                                angularCompileRows: true,
                                localeTextFunc: agGridService.transalteFunc,
                                onFirstDataRendered(params: $TSFixMe) {
                                    params.api.sizeColumnsToFit();
                                },
                                onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                            },
                            getDetailRowData: function (params: $TSFixMe) {
                                params.successCallback(params.data.skus);
                            }
                        },
                        getRowHeight: function (params: $TSFixMe) {
                            if (params.node && params.node.detail) {
                                const offset = 80;
                                const allDetailRowHeight = params.data.skus.length * 28;
                                return allDetailRowHeight + offset;
                            } else {
                                // otherwise return fixed master row height
                                return 30;
                            }
                        }
                    };
                }

                function processWatches() {
                    $scope.$watch("$ctrl.parametersForm.$valid", updateIsValid);
                    $scope.$watch("$ctrl.forecast.market.brands", updateIsValid, true);
                    $scope.$watch("$ctrl.forecast.parameters.forecastType.typeId", updateIsValid, true);
                    $scope.$watch("$ctrl.brandsFromIms", brandGridDataChanged, true);
                }

                function brandGridDataChanged() {
                    if (!$ctrl.forecast || !$ctrl.forecast.market || $ctrl.isForecastSet) return;

                    var filtered = _.filter($ctrl.brandsFromIms, (b: $TSFixMe) =>
                        _.some(b.skus, (s: $TSFixMe) => s.isSelected)
                    );
                    var isGrouped = false;

                    var grouped = _.groupBy(filtered, (b: $TSFixMe) =>
                        (isGrouped = b.brandGroup) ? b.brandGroup : b.name
                    );

                    $ctrl.forecast.market.brands = _.map(grouped, (brands: $TSFixMe, key: $TSFixMe) => {
                        var skus = _.filter(
                            _.flatten(_.pluck(brands, "skus")),
                            (s: $TSFixMe) => s.isSelected && s.canBeForecast && s.oracleIndex
                        );

                        return {
                            name: key,
                            externalIds: _.without(_.flatten(_.pluck(brands, "externalId")), undefined, null),
                            skus: _.map(skus, (s: $TSFixMe) => {
                                var brand;
                                if (isGrouped) {
                                    brand = _.find(brands, (b: $TSFixMe) =>
                                        _.some(b.skus, (otherSku: $TSFixMe) => otherSku.oracleIndex == s.oracleIndex)
                                    );
                                }
                                return {
                                    externalId: s.externalId,
                                    name: isGrouped ? brand.name + " - " + s.name : s.name,
                                    oracleIndex: s.oracleIndex,
                                    pharmacyMarket: s.pharmacyMarket,
                                    dddFact: s.dddFact,
                                    newProductId: s.newProductId,
                                    scSkuName: s.scSkuName,
                                    scDiscounts: s.scDiscounts,
                                    scCOGs: s.sccoGs
                                };
                            }),

                            molecules: _.first(brands).molecules,
                            assumptions: {
                                risks: []
                            },
                            scProjectName: _.first(brands).scProjectName,
                            scTradeTerms: _.first(brands).scTradeTerms,
                            scMarketingBudgets: _.first(brands).scMarketingBudgets,
                        };
                    });
                }

                function createBrandsFromIms() {
                    $ctrl.brandsFromIms = $ctrl.forecast.market.brands.map((b: $TSFixMe) => ({
                        name: b.name,

                        skus: b.skus.map((s: $TSFixMe) => ({
                            dddFact: s.dddFact,
                            name: s.name,
                            pharmacyMarket: s.pharmacyMarket,
                            oracleIndex: s.oracleIndex
                        }))
                    }));
                    if ($ctrl.gridApi) {
                        $ctrl.gridApi.setRowData($ctrl.brandsFromIms);
                    }
                }

                function updateIsValid() {
                    $ctrl.isValid =
                        $ctrl.parametersForm.$valid &&
                        !angular.isUndefinedOrNull($ctrl.forecast.market) &&
                        !angular.isUndefinedOrNull($ctrl.forecast.market.brands) &&
                        $ctrl.forecast.market.brands.length > 0 &&
                        $ctrl.isDDDFactValid();
                }

                $ctrl.isDDDFactValid = () => {
                    if (
                        !$ctrl.forecast.parameters.forecastType ||
                        $ctrl.forecast.parameters.forecastType.typeId != "dot"
                    )
                        return true;

                    return _.every($ctrl.forecast.market.brands, (b: $TSFixMe) =>
                        _.every(b.skus, (s: $TSFixMe) => s.dddFact)
                    );
                };
            }
        ]
    });
})(angular.module("topline.modules"));
